import { http }           from '@/http'
import GeolocationHandler from './../GeolocationHandler'

const API_RESOURCE_DICTIONARY = 'Dictionary'

export default new class {

  constructor () {
    this.geolocationHandler = GeolocationHandler
  }

  /**
   *
   * @return {Promise<any> | * | Thenable<any> | PromiseLike<T | never> |
   *   Promise<T | never>}
   */
  get () {
    let args = {}

    return this.geolocationHandler.getPromise().then(() => {
      this.geolocationHandler.extendArgs(args)

      return http.get(API_RESOURCE_DICTIONARY, {
        params: args
      })
    })

  }
}
